import React from 'react';
import { Transaction as UITransition } from '@shopee/chatbot-ui';
import { TransactionProps } from '@shopee/chatbot-ui/lib/components/Transaction';


const Transaction = (props: TransactionProps) => {
  return <UITransition {...props} />;
};

export default Transaction;
